import { TransferPasswordToGroupEntry } from "./TransferPasswordToGroupEntry";

export class TransferPasswordsToGroupRequest {
    gid: number;
    entries: TransferPasswordToGroupEntry[] = [];
}